<!-- TEMPLATE -->
<template >
  <div class="content" style="padding-top: 0px">
    <DialogAddPhishingDomain
      v-bind:show.sync="show_add_phishing_domain_dialog"
      :key="1"
    />

    <div class="row">
      <div class="col-lg-10">
        <TimeFilters />
      </div>
      <div class="col-lg-2">
        <!-- domain list -->
        <DomainListDropdown
          v-bind:style="[isMobile ? { color: 'black' } : { color: 'white' }]"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <google-maps :data="websites" />
      </div>
    </div>

    <DomainStatistics />

    <div class="row">
      <div class="col-lg-12">
        <v-btn
          v-on:click="showAddPhishingDomainDialog()"
          class="btn btn-icon"
          dark
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <ExportReport />
      </div>
    </div>

    <PhishingWebsitesDatatable />

    <br />
  </div>
</template>

<!-- SCRIPT -->
<script>
import PhishingWebsitesDatatable from "./PhishingWebsitesDatatable.vue";
import DomainStatistics from "./DomainStatistics.vue";
import DialogAddPhishingDomain from "./DialogAddPhishingDomain.vue";
import TimeFilters from "./TimeFilters.vue";
import ExportReport from "./ExportReport.vue";
import GoogleMaps from "./GoogleMaps.vue";
import DomainListDropdown from "./DomainListDropdown.vue";

export default {
  name: "MainComponent",
  data: function () {
    return {
      userInfo: this.$store.state.cognitoInfo,
      show_add_phishing_domain_dialog: false,
    };
  },
  computed: {
    websites: function () {
      return this.$store.state.phishingWebsites;
    },
  },
  methods: {
    showAddPhishingDomainDialog() {
      this.show_add_phishing_domain_dialog = true;
    },
  },

  components: {
    PhishingWebsitesDatatable,
    DomainStatistics,
    TimeFilters,
    ExportReport,
    GoogleMaps,
    DialogAddPhishingDomain,
    DomainListDropdown,
  },
};
</script>

<!-- Style -->
<style>
</style>